module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-halloween-right-2f0497f17975417611e9e2110ede8ed4.svg";